(() => {
  const initialize = (root = document) => {
    const section = root.matches?.('.section-header') ? root : document.querySelector('.section-header');
    if (!section) return;

    const template = document.querySelector('main[data-template]')?.dataset.template;
    section.classList.toggle('tz-home-header', template === 'index');

    section.querySelectorAll('details').forEach((details) => {
      if (details.dataset.tzHeaderObserved === 'true') return;
      details.dataset.tzHeaderObserved = 'true';

      details.addEventListener('toggle', () => {
        const isMobileRoot = details.id === 'Details-menu-drawer-container';
        const payload = {
          id: details.id || null,
          label: details.querySelector(':scope > summary')?.textContent?.trim() || null,
        };

        if (details.open) {
          document.dispatchEvent(new CustomEvent('treezyn:menu:opened', { detail: payload }));
          if (isMobileRoot) {
            document.dispatchEvent(new CustomEvent('treezyn:mobile-nav:opened', { detail: payload }));
          }
        } else {
          document.dispatchEvent(new CustomEvent('treezyn:menu:closed', { detail: payload }));
          if (isMobileRoot) {
            document.dispatchEvent(new CustomEvent('treezyn:mobile-nav:closed', { detail: payload }));
          }
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  }
})();
